import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Contacts',
  basePath: '/work',
  columns: [
    { key: 'contact_type', label: 'Contact Type', sortable: true },
    { key: 'work_company', label: 'Brand/Company', sortable: true },
    { key: 'work_person', label: 'Contact Person', sortable: true },
    { key: 'companytype_name', label: 'Sector', sortable: true },
    { key: 'last', label: 'Last Change', sortable: true },
    { key: 'user_name', label: 'User', sortable: true },
  ],
  fields: [
    { key: 'work_person', label: 'Contact person', type: 'text' },
    { key: 'work_company', label: 'Brand/Company', type: 'text' },
    { key: 'work_phone', label: 'Phone', type: 'text' },
    { key: 'work_email', label: 'Email', type: 'text' },
    { key: 'work_profile', label: 'Relevant information about brand or company', type: 'rich-text' },
    { key: 'companytype_id', label: 'Sector', type: 'async-select',
      optionsUrl: '/company-types/options',
      placeholder: 'Select sector' },
    { key: 'work_who', label: 'Contact type', type: 'async-select',
      optionsUrl: '/contact-types/options',
      placeholder: 'Select contact type', defaultValue: '1' },
    { key: 'user_id', label: 'Inserted by', type: 'async-select',
      optionsUrl: '/users-admin/options',
      placeholder: 'Select user' },
    { key: 'last', label: 'Last change', type: 'datetime' },
    { key: 'followup', label: 'Followup', type: 'yesno', defaultValue: '0' },
    { key: 'next', label: 'Planned contact', type: 'datetime',
      dependsOn: ['followup'],
      visible: (v) => v.followup == 1 },
    { key: 'work_text', label: 'Information about contacting', type: 'rich-text' },
  ],
  filters: [
    { key: 'srch', label: 'Search', type: 'text' },
    { key: 'email', label: 'Email', type: 'text' },
    { key: 'contactType', label: 'Contact Type', type: 'select',
      optionsUrl: '/contact-types/options' },
    { key: 'companyType', label: 'Sector', type: 'select',
      optionsUrl: '/company-types/options' },
    { key: 'user', label: 'User', type: 'select',
      optionsUrl: '/users-admin/options' },
  ],
  defaultSort: { field: 'contact_type', dir: 'asc' },
});
